module.exports = __webpack_public_path__ + "static/media/family.5630e4c1.svg";